'use client'

import * as SwitchPrimitives from '@radix-ui/react-switch'
import * as React from 'react'

import { cn } from '@/theme/utils'

const UiSwitch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer focus-visible:ring-ring focus-visible:ring-offset-background inline-flex h-6 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent bg-[#141722] transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'data-[state=checked]:bg-primary pointer-events-none block h-5 w-7 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-6 data-[state=checked]:shadow-lg data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-white',
      )}
    />
  </SwitchPrimitives.Root>
))
UiSwitch.displayName = SwitchPrimitives.Root.displayName

export { UiSwitch }
